export default "__VITE_ASSET__2220d313__"